// frontend/src/pages/forgotPassword/ForgotPassword.jsx

import axios from "axios";
import "./forgotPassword.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Context } from "../../context/Context";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const otpRef = useRef();
  const newPasswordRef = useRef();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const { dispatch } = useContext(Context);
  const [otp, setOtp] = useState(false);
  const [verify, setVerify] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const [otpEmail, setOtpEmail] = useState("");

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setInterval(() => setCooldown((c) => c - 1), 1000);
    return () => clearInterval(t);
  }, [cooldown]);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const sendOtp = async (e) => {
    e.preventDefault();
    if (isSending || cooldown > 0) return;

    try {
      const normalizedEmail = email.trim().toLowerCase();
      if (!normalizedEmail) {
        toast.error("Please enter your email.");
        return;
      }
 
      setIsSending(true);
      const res = await axios.post("/auth/forgotpassword", {
        email: normalizedEmail,
      });

      if (res.data && res.data.ok === false) {
        toast.error(res.data.msg || "Could not send One-Time Password.");
        return;
      }

      setOtpEmail(normalizedEmail);
      setOtp(true);
      setCooldown(60);
      toast.success("One-Time Password sent successfully! Please check your email");
    } catch (err) {
      console.log(err)
      toast.error(err?.response?.data?.msg || "Error sending One-Time Password!");
    } finally {
      setIsSending(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    if (isSending) return;

    try {
      const normalizedEmail = (otpEmail || email).trim().toLowerCase();
      const enteredOtp = (otpRef.current?.value || "").trim();
      if (!enteredOtp) {
        toast.error("Please enter the One-Time Password.");
        return;
      }

      setIsSending(true);

      const res = await axios.post("/auth/verifyotp", {
        email: normalizedEmail,
        otp: enteredOtp,
      });

      if (res.data && res.data.ok === false) {
        toast.error(res.data.msg || "Couldn't verify One-Time Password!");
        return;
      }

      toast.success("Verify One-Time Password successfully!");
      setVerify(true);
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.msg || "Couldn't verify One-Time Password!");
    } finally {
      setIsSending(false);
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    if (isSending) return;

    const newPassword = (newPasswordRef.current?.value || "").trim();
    if (newPassword.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }

    try {
      const normalizedEmail = (otpEmail || email).trim().toLowerCase();
      setIsSending(true);

      const res = await axios.put("/auth/resetpassword", {
        email: normalizedEmail,
        newPassword,
      });

      if (res.data && res.data.ok === false) {
        toast.error(res.data.msg || "Error Changing Password!");
        return;
      }

      toast.success("Password has been changed successfully!");

      navigate("/login", {
        state: { reset: true },
      });
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.msg || "Error Changing Password!");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
    <style>
      {`
        .main-content {
          display: none !important;
        }
      `}
    </style>
    <div className="page-container-forgot-password">
      <div className="left-container-forgot-password">
        <Link to="/">
          <img
            src={process.env.REACT_APP_AWS_S3_IMAGE_FRONTEND_URL + "/logo1.png"}
            alt="For Love of Writers Logo"
            className="logo-forgot-password"
          />
        </Link>
        <img
          src={process.env.REACT_APP_AWS_S3_IMAGE_FRONTEND_URL + "/bottom_image.jpg"}
          alt="Your Image"
          className="picture"
        />
      </div>
      <div className="right-container-forgot-password">
        {verify ? (
          <form className="form-reset-password">
            <h1>
              Reset Password
            </h1>
            <div className="input-container-reset-password">
              <label htmlFor="new-password">New Password</label>
              <input
                type="password"
                name="new-password"
                id="new-password"
                ref={newPasswordRef}
                placeholder="Enter your new Password"
                required
                className="input-reset-password"
              />
              <div style={{ justifyContent: "center", paddingTop: "20px" }}>
                <button className="reset-password-btn" onClick={resetPassword} disabled={isSending}>
                  Reset Password
                </button>
              </div>
            </div>
          </form>
        ) : (
          <form className="form-forgot-password">
            <h1>
              Forgot Password
            </h1>
            <div className="input-container-forgot-password">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                name="email"
                id="email"
                onChange={handleChange}
                placeholder="Email Address"
                required
                className="input-forgot-password"
                disabled={otp}
              />
              <div style={{ justifyContent: "center", paddingTop: "10px" }}>
                {otp ? (
                  <>
                    <input
                      name="otp"
                      id="otp"
                      placeholder="Enter One-Time Password Here"
                      required
                      ref={otpRef}
                      className="input-forgot-password"
                    />
                    <div className="forgot-button-container">
                      <button className="verify-otp-btn" onClick={verifyOtp} disabled={isSending}>
                        Verify One-Time Password
                      </button>
                      <button
                        className="resend-otp-btn"
                        onClick={sendOtp}
                        disabled={isSending || cooldown > 0}
                      >
                        {cooldown > 0 ? `Resend in ${cooldown}s` : "Resend One-Time Password"}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <button className="send-otp-btn" onClick={sendOtp} disabled={isSending}>
                      Send One-Time Password
                    </button>
                  </>
                )}
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
    </>
  );
}
